var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.77 29.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.21.2s-.01,0-.02,0h-.01s0,0,0,0c0,0,0,0,0,0H4.55C2.11.25.17,2.27.22,4.68v23.94c0,.4.24.76.6.92.13.05.26.08.4.08.25,0,.5-.09.69-.27l4.22-4,4.22,4c.39.37.99.37,1.38,0l4.22-4,4.22,4c.29.28.71.35,1.08.19.37-.16.6-.52.6-.92v-12.72h5.69c.55,0,1-.45,1-1V4.7c.05-2.42-1.87-4.43-4.33-4.5Zm-4.36,26.1l-3.22-3.05c-.38-.37-.99-.37-1.38,0l-4.22,4-4.22-4c-.39-.37-.99-.37-1.38,0l-3.22,3.05V4.66c-.03-1.33,1.03-2.44,2.34-2.47h16c-.47.72-.74,1.57-.72,2.49v10.23s0,11.39,0,11.39Zm6.69-12.39h-4.69V4.66c-.03-1.33,1.03-2.43,2.32-2.47h.02c1.33.03,2.39,1.14,2.36,2.49v9.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.39,16.98H5.68c-.55,0-1,.45-1,1s.45,1,1,1h10.71c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.39,10.84H5.68c-.55,0-1,.45-1,1s.45,1,1,1h10.71c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.7a5309ea577cdb1cfd24347b837b0ba8.svg";
export { ForwardRef as ReactComponent };